import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b4d43ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b4d43ec&scoped=true&tips=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d43ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4d43ec')) {
      api.createRecord('0b4d43ec', component.options)
    } else {
      api.reload('0b4d43ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b4d43ec&scoped=true", function () {
      api.rerender('0b4d43ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/community/content/index.vue"
export default component.exports